module.exports = __webpack_public_path__ + "img/app-footer.6c115b9.svg";